import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const DateContainer = styled.span`
    opacity: 70%;
    font-family: AvenirNextWorld Demi;
    font-size: 11px;
    color: #202124;
    ${media.smalDevice`
        display: grid;
    `}
`;
export const TimeContainer = styled.span`
    font-family: AvenirNextWorld Regular;
    opacity: 100%;
    font-size: 10px;
    color: #202124;
    margin-top: 8px;
`;

export const Status = styled.span`
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    word-break: break-all;
`;

export const Tag = styled.span`
    font-family: AvenirNextWorld Regular;
    font-size: 12px;
    color: #4f4f4f;
    margin-top: 8px;
    word-break: ${({ canceledBy }) => (canceledBy ? '' : 'break-all')};
    ${media.mobileDevice`
        line-height: ${({ lineHeight }) => lineHeight};
    `}
`;

export const Span = styled.span`
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${media.smalDevice`
        display: grid;
    `}
`;

export const SpanStatus = styled.span`
    ${media.smalDevice`
        display: grid;
    `}
`;

export const Character = styled.span`
    padding: 0rem 0.3rem;
    ${media.smalDevice`
        display: none;
    `}
`;

export const HistoryContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

// Prime Timeline default CSS

export const Demo = styled.div`
    .custom-marker {
        display: flex;
        width: 2rem;
        height: 2rem;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        border-radius: 50%;
        z-index: 1;
    }

    .p-timeline-event-content,
    .p-timeline-event-opposite {
        line-height: 1;
    }

    .p-timeline-event-separator,
    .p-timeline-event-connector {
        border-left: 0px dashed #707070;
    }

    .p-timeline-event-connector {
        border-left: 1px dashed #707070;
    }
    .p-timeline .p-timeline-event-connector {
        background-color: #ffffff;
    }

    .p-shadow-2 {
        box-shadow: none;
    }

    .p-timeline.p-timeline-vertical .p-timeline-event-opposite,
    .p-timeline.p-timeline-vertical .p-timeline-event-content {
        padding: 0.3rem 1rem;
        opacity: 70%;
    }

    //left alignment
    .p-timeline-event-opposite {
        flex: 0.5;
        padding: 0 1rem;
    }

    .p-timeline {
        margin: 1rem 0rem;
    }

    ${media.exSmallDevice`

        .timeline-demo .customized-timeline .p-timeline-event-opposite {
            flex: 0;
        }

        {
        .timeline-demo .customized-timeline .p-timeline-event:nth-child(even) {
            flex-direction: row !important;
        }
        .timeline-demo
            .customized-timeline
            .p-timeline-event:nth-child(even)
            .p-timeline-event-content {
            text-align: left !important;
        }
        
        .timeline-demo .customized-timeline .p-card {
            margin-top: 1rem;
        }
    }
    `}
`;
